import React from "react";
import moment from "moment";
import { Tooltip } from "react-tippy";
import "react-tippy/dist/tippy.css";
import "../styles/components/uptime-chart.scss";

const UptimeTimeline = props => {
  const aDayBeforeLastCheck = moment(props.lastCheckAt).subtract(24, "hours");

  const data = generateData(
    props.firstCheckAt,
    props.lastCheckAt,
    aDayBeforeLastCheck,
    props.downtimes
  );
  return (
    <div className="uptime">
      <div className="numbers">
        <strong>{`${props.uptime}%`}</strong>
        <span>Uptime</span>
      </div>
      <div className="history">
        <div className="uptime-timeline">
          <output>
            {data.map((el, index) => {
              if (el.type === "disable" && el.width !== 0) {
                return (
                  <i
                    className="disabled"
                    style={{ width: `${el.width}%` }}
                    key={index}
                  />
                );
              } else if (el.type === "up" && el.width !== 0) {
                return (
                  <i
                    className="fill"
                    style={{ width: `${el.width}%` }}
                    key={index}
                  />
                );
              } else if (el.type === "down") {
                const from_time = moment(el.from_time).format("HH:mm:ss");
                const to_time = moment(el.to_time).format("HH:mm:ss");
                const duration = moment
                  .duration(moment(el.to_time).diff(el.from_time))
                  .asSeconds();
                const formatedDuration = formatTime(duration);
                return (
                  <Tooltip
                    title={` ${from_time} - ${to_time} (${formatedDuration})`}
                    size="big"
                    theme="light"
                    arrow="true"
                    style={{ width: `${el.width}%` }}
                    key={index}
                  >
                    <i
                      className={`down ${duration < 300 ? "down-little" : ""}`}
                    />
                  </Tooltip>
                );
              }
              return undefined;
            })}
          </output>
        </div>
      </div>
    </div>
  );
};

const generateData = (
  firstCheckAt,
  lastCheckAt,
  aDayBeforeLastCheck,
  downtimes
) => {
  const data = [];
  if (firstCheckAt && lastCheckAt && aDayBeforeLastCheck && downtimes) {
    const everySecWidth = 100 / (24 * 60 * 60);
    // calculate disable time width
    const disableTimeWidth =
      moment
        .duration(moment(firstCheckAt).diff(aDayBeforeLastCheck))
        .asSeconds() * everySecWidth;
    data.push({ width: disableTimeWidth, type: "disable" });
    // calculate up and down time width
    if (downtimes.length === 0) {
      const uptimeWidth =
        moment.duration(moment(lastCheckAt).diff(firstCheckAt)).asSeconds() *
        everySecWidth;
      data.push({ width: uptimeWidth, type: "up" });
      return data;
    }

    for (var i = 0; i < downtimes.length; i++) {
      if (i === 0) {
        const uptimeWidth =
          moment
            .duration(moment(downtimes[i].from_time).diff(firstCheckAt))
            .asSeconds() * everySecWidth;
        data.push({ width: uptimeWidth, type: "up" });
      } else {
        const uptimeWidth =
          moment
            .duration(
              moment(downtimes[i].from_time).diff(downtimes[i - 1].to_time)
            )
            .asSeconds() * everySecWidth;
        data.push({ width: uptimeWidth, type: "up" });
      }
      const downtimeWidth =
        moment
          .duration(moment(downtimes[i].to_time).diff(downtimes[i].from_time))
          .asSeconds() * everySecWidth;
      data.push({
        width: downtimeWidth,
        type: "down",
        from_time: downtimes[i].from_time,
        to_time: downtimes[i].to_time
      });

      if (i === downtimes.length - 1) {
        const uptimeWidth =
          moment
            .duration(moment(lastCheckAt).diff(downtimes[i].to_time))
            .asSeconds() * everySecWidth;
        data.push({ width: uptimeWidth, type: "up" });
      }
    }
  }
  return data;
};

const formatTime = sec => {
  var hours = Math.floor(sec / 3600);
  var minutes = Math.floor((sec - hours * 3600) / 60);
  var seconds = sec - hours * 3600 - minutes * 60;

  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  return hours + ":" + minutes + ":" + seconds;
};

export default UptimeTimeline;
